import { CanActivateChildFn, CanActivateFn, GuardResult, RedirectCommand, Router } from '@angular/router';
import { ClientAuthService } from '../client-auth.service';
import { ClientAccountService } from '../api-services/client-account.service';
import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

async function canActivate(): Promise<GuardResult> {
  return await new Promise<GuardResult>(resolve => {
    const clientAuthService = inject(ClientAuthService);
    const clientAccountsService = inject(ClientAccountService);
    const router = inject(Router);

    const clientLoginToken = clientAuthService.GetAuthToken();
    if (clientLoginToken !== null) {
      clientAccountsService.GetCurrentAccount().subscribe({
        next: apiResponse => {
          clientAuthService.CurrentClientAccount.set(apiResponse.Data!);
          return resolve(true);
        },
        error: (httpError: HttpErrorResponse) => {

          if (httpError.status === 403) {
            return resolve(new RedirectCommand(router.createUrlTree(["/"])));
          }

          return resolve(false);
        }
      });
    } else {
      return resolve(new RedirectCommand(router.createUrlTree(["/"])));
    }
  });
};

export const clientAuthChildrenGuard: CanActivateChildFn = async () => {
  return await canActivate();
};

export const clientAuthGuard: CanActivateFn = async () => {
  return await canActivate();
};